/**
 * File lazy-load.js.
 *
 * Handles lazy loading the images.
 */

const initializeLazyImageIntersectionObserver = () => {
  const lazyImages = Array.from(document.querySelectorAll('img.lazy'))

  if (lazyImages.length === 0) {
    return
  }
  let lazyImageObserver

  const loadImageIfElementOnScreen = (entry) => {
    if (entry.isIntersecting) {
      entry.target.src = entry.target.dataset.src
      lazyImageObserver.unobserve(entry.target)
    }
  }

  const observeVisibility = (lazyImage) => {
    lazyImageObserver.observe(lazyImage)
  }

  const setSrc = (element) => {
    element.src = element.dataset.src
  }

  if (typeof window.IntersectionObserver === 'function') {
    lazyImageObserver = new IntersectionObserver((entries) => {
      entries.forEach(loadImageIfElementOnScreen)
    })
    lazyImages.forEach(observeVisibility)
  } else {
    lazyImages.forEach(setSrc)
  }
}

const initializeIntersectionObserver = () => {
  initializeLazyImageIntersectionObserver()
}

if (typeof document.readyState === 'string' && document.readyState === 'complete') {
  initializeIntersectionObserver()
} else {
  document.addEventListener('DOMContentLoaded', initializeIntersectionObserver, true)
}
